export * from "./useLocatorTranslations";
